const info = {
  ZH: { //中文翻译
    searchMds: '\u67E5\u8BE2MDS',
    search: '\u67E5\u627E',
    delMds: '\u5220\u9664MDS',
    confirmDel: '\u60A8\u786E\u5B9A\u60F3\u8981\u5220\u9664\u6240\u9009MDS\u5417?',
    productName: '\u4EA7\u54C1\u540D\u79F0',
    shortNumber: '\u96F6\u90E8\u4EF6\u53F7,\u534A...',
    longNumber: '\u96F6\u90E8\u4EF6\u53F7,\u534A\u6210\u54C1\u4EF6\u53F7,\u6750\u6599\u53F7',
    version: '\u7248\u672C',
    delete: '\u5220\u9664',
    isDelAll: '\u672C\u6750\u6599\u6570\u636E\u8868/\u7EC4\u4EF6\u5355\u5143\u8FD8\u6709\u5176\u4ED6\u7248\u672C\u5B58\u5728. \u60A8\u8981\u5220\u9664\u6240\u6709\u7248\u672C\u5417',
    undeletable: '\u4E0D\u53EF\u5220\u9664\u7248\u672C',
    delAll: '\u5220\u9664\u6240\u6709',
    cancel: '\u53D6\u6D88',
    success: '\u64CD\u4F5C\u5DF2\u6210\u529F\!',
    success1: '\u5DF2\u6279\u51C6\u6216\u5DF2\u4E0B\u8F7D\u7684MDS\u65E0\u6CD5\u5220\u9664\uFF0C\u5176\u4F59\u8868\u5355\u5220\u9664\u6210\u529F\uFF01',
    newSearch: '\u65B0\u7684\u67E5\u627E',
  },
  EN: { //英文翻译
    searchMds: 'Search MDS',
    search: 'Search',
    delMds: 'Delete MDS',
    confirmDel: 'Are you sure to delete it?',
    productName: 'product name',
    shortNumber: 'Component No....',
    longNumber: 'Component No., Semicomponent No., Material No.',
    version: 'Version',
    delete: 'delete',
    isDelAll: 'The MDS or module exist other versions,do you want delete all?',
    delAll: 'delete all',
    cancel: 'cancel',
    success: 'The operation has been successful\!',
    newSearch: 'Find new',
    success1: 'The operation has been successful except for the accepted or downloaded MDS\uFF01',
    undeletable: 'undeletable',

  }
}
export default info //需要暴露出去
